import React from 'react';

interface TagSchemaFieldChipProps {
  name: string;
}

export default function TagSchemaFieldChip({name}: TagSchemaFieldChipProps): JSX.Element {
  return (
    <div className="file-tag">
      <span>{name}</span>
    </div>
  );
}
